import React from 'react';
import { format, getDay, setDay, addDays, parse } from 'date-fns';
import { useState } from 'react';
import FieldTable from '../../components/field-table';
import { SitePlanning, usePlanningReportLazyQuery } from '../../generated/graphql';
import { get } from 'immutadot';
import * as XLSX from 'xlsx';
import {Button,  FormLabel} from "@mui/material";
import {Download, RefreshSharp} from "@mui/icons-material";
import {ModalWindow} from "../../components/ModalWindow";
import {useSnackbar} from "notistack";

let today = new Date();
today = getDay(today) < 1 ? setDay(today, -5, { weekStartsOn: 1 }) : setDay(today, 1, { weekStartsOn: 1 })
const mondayString = format(today, 'yyyy-MM-dd');
const sundayString = format(addDays(today, 6), 'yyyy-MM-dd');


function dateToExcel(inDate) {
    const returnDateTime = 25569.0 + ((inDate.getTime() - (inDate.getTimezoneOffset() * 60 * 1000)) / (1000 * 60 * 60 * 24));
    return returnDateTime.toString().substr(0, 5);
}

const ftColumns = [
    {
        accessor: 'data.id',
        noSort: true,
        dataType:'selector'
    }, {
        accessor: 'name',
        header: 'Site Name',
        dataType:'default'
        // eslint-disable-next-line react/display-name
    }, {
        accessor: 'region.name',
        header: 'Region',
        dataType: 'default'
    }];


const PlanningReport = (props) => {
    const [selectedRows, setSelectedRows] = useState({});
    const [dateFromValue, setDateFromValue] = useState(mondayString);
    const [dateToValue, setDateToValue] = useState(sundayString);
    const [isWait, setWait] = useState(false);
    const [query, { loading}] = usePlanningReportLazyQuery();
    const currency = { glyph: '£' };
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    /*function setDateFrom(evt) {
        setDateFromValue(evt.target.value);
    }
    function setDateTo(evt) {
        setDateToValue(evt.target.value);
    }*/
    async function submitForm() {
        if (isWait) return;
        if (!dateFromValue || !dateToValue) return;
        const selectedIds = [];
        Object.entries(selectedRows).forEach(function ([name, value]) {
            if (value) {
                selectedIds.push(name);
            }
        });
        if (!selectedIds.length) {
            enqueueSnackbar('Please select sites before generating report',{variant:'error'});
            return;
        }
        enqueueSnackbar('Generating report',{variant:'info',key:'REPORT_GEN'});
        setWait(true);
        try {
            closeSnackbar('REPORT_GEN');
            enqueueSnackbar('Rendering file',{variant:'success',key:'REPORT_RENDER'});
            const res = await query({ variables: { ids: selectedIds } });
            if(res.data) {
                const data = res.data;
        //        AppToaster.show({ message: 'Rendered file', intent: 'success' }, toastKey);
                const op = [];
                const pixPerLetter = 7;
                const rawValues = data.sites;
                const tableValues:SitePlanning[] = [];
                rawValues?.forEach((site) => {
                    site?.sitePlannings?.forEach((planning) => {
                        const p: SitePlanning = Object.assign({}, planning);
                        p.siteName = site.name;
                        tableValues.push(p);
                    });
                });
                console.log('values is', tableValues);
                const eData = [];
                const columns = [
                    {
                        accessor: 'siteName',
                        header: 'Site'
                    }, {
                        accessor: 'planningStage.label',
                        header: 'Stage'
                    }, {
                        header: 'Outcome',
                        accessor: 'planningOutcome.label'
                    }, {
                        accessor: 'notes',
                        header: 'Notes'
                    }, {
                        accessor: 'outcome_notes',
                        header: 'Outcome Notes'
                    }, {
                        accessor: 'amount',
                        header: 'Amount',
                        exportAs: 'currency'
                    }, {
                        accessor: 'planning_date',
                        header: 'Planning Date',
                        exportAs: 'date-iso'
                    }, {
                        accessor: 'outcome_date',
                        header: 'Outcome Date',
                        exportAs: 'date-iso'
                    }
                ];
                const worksheet = { '!ref': 'A1:' };
                let col = 1;
                const colwidths = [];
                columns.forEach((column) => {
                    const header = column.headerRaw ? column.headerRaw : column.header;
                    worksheet[String.fromCharCode(64 + col) + 1] = { t: 's', v: header };
                    colwidths.push({ wpx: header.toString().length });
                    col++;
                });
                worksheet['!ref'] = 'A1:' + String.fromCharCode(64 + col) + '1';
                eData.push(columns.map((column) => column.header));
                let rowIdx = 2;
                let lastCell = '';
                tableValues.forEach((row) => {
                    //var newRow = [];
                    let col = 1;
                    columns.forEach((column) => {
                        const cell = { t: 's', v: undefined, f: undefined, w: undefined, z: undefined };
                        let value: any = null;
                        value = get(row, column.sort ? column.sort : column.accessor);
                        const rawValue = value;
                        switch (column.exportAs) {
                            case 'number':
                                cell.t = 'n';
                                cell.v = value;
                                if (isNaN(value) || value === null) {
                                    cell.v = 0;
                                }
                                break;
                            case 'date-uk':
                                cell.t = 'n';
                                cell.z = 'dd/mm/yyyy';
                                var dateValue = parse(value, 'dd/MM/yyyy', new Date());
                                //console.log('parsing',value,parse(value, 'dd/MM/yyyy', new Date()),!!parse(value, 'dd/MM/yyyy', new Date()));
                                cell.v = isNaN(dateValue.getTime()) ? '' : dateToExcel(dateValue);
                                //value = parse(value, 'dd/MM/yyyy', new Date());
                                break;
                            case 'date-iso':
                                cell.t = 'n';
                                cell.z = 'dd/mm/yyyy';
                                //console.log('parsing',value,parse(value, 'yyyy-MM-dd', new Date()));
                                cell.v = dateToExcel(parse(value, 'yyyy-MM-dd', new Date()));
                                //value = parse(value, 'dd/MM/yyyy', new Date());
                                break;
                            case 'percentage':
                                cell.t = 'n';
                                //                        cell.v = parseFloat(value?value.replace('%', ''):'');
                                cell.z = '#.##"%"';
                                cell.v = value;
                                if (typeof value == 'number') {
                                    cell.v = value / 100;
                                }
                                if (typeof value == 'string') {
                                    cell.v = parseFloat(value ? value.replace('%', '') : '');
                                }
                                if (isNaN(cell.v) || cell.v == null) {
                                    cell.v = 0;
                                }
                                //cell.w = value; 
                                //value = parseFloat(value.replace('%', ''));
                                break;
                            case 'currency':
                                cell.t = 'n';
                                cell.v = value;
                                if (typeof value == 'number') {
                                    cell.v = value / 100;
                                }
                                if (typeof value == 'string') {
                                    cell.v = parseFloat(value ? value.replace(/[^0-9\\.]/, '') : '');
                                }
                                if (isNaN(cell.v) || cell.v === null) {
                                    cell.v = 0;
                                }
                                console.log('cell is', cell);
                                //                        if(!cell.v) { cell.v = value; }
                                cell.z = '"' + (currency?.glyph ? currency.glyph : '£') + '"' + '0.00';
                                //cell.w = value;
                                break;
                            case 'boolean':
                                if (typeof value == 'object') {
                                    cell.v = rawValue ? 'Y' : 'N';
                                } else {
                                    cell.v = value ? 'Y' : 'N';
                                }
                                break;
                            default:
                                if (typeof value == 'object') {
                                    if (value) {
                                        value = value.toString();
                                        cell.v = value;
                                    } else {
                                        cell.v = ''; value = '';
                                    }
                                }
                                else {
                                    cell.v = value;
                                }
                                break;
                        }
                        if (cell.v) {
                            colwidths[col - 1].wpx = Math.max(colwidths[col - 1].wpx, cell.v.toString().length);
                        }
                        lastCell = String.fromCharCode(64 + col++) + rowIdx;
                        worksheet[lastCell] = cell;
                        //newRow.push(value);
                    });
                    rowIdx++;
                    //            return newRow;
                });
                worksheet['!ref'] = 'A1:' + lastCell;
                colwidths.forEach(v => { v.wpx = v.wpx * pixPerLetter; });
                console.log('widths', colwidths);
                worksheet['!cols'] = colwidths;
                console.log('worksheet is', worksheet);
                //if (eData.length > 1) {
                //const ws = XLSX.utils.aoa_to_sheet(eData);
                //var ws = XLSX.utils.aoa_to_sheet(eData);
                const wb = XLSX.utils.book_new();
                //var cell = ws['A2'];
                //console.log(worksheets);
                //worksheet['A2'] = {t:'s',v: 'TEST'};
                XLSX.utils.book_append_sheet(wb, worksheet, "SheetJS");
                XLSX.writeFile(wb, "planning.xlsx");
                closeSnackbar('REPORT_RENDER');
                enqueueSnackbar('Report rendered',{variant:'success',key:'REPORT_RENDERED'});
                props.doClose();
                    }
            setWait(false);
            //AppToaster.show({ message: 'Rendering file', intent: 'success' }, toastKey);
            //            var res = await fetch(data?.data?.siteRevenueReport?.reportData);
            //var blobContent = await res.blob();
            //const blobUrl = URL.createObjectURL(blobContent);
            //FileSaver.saveAs(blobContent,'site-revenue-report-'+dateFromValue+'__'+dateToValue+'.xlsx');
            //window.open(blobUrl);
        } catch (e) {
            console.log(e);
            closeSnackbar('REPORT_RENDER');
            enqueueSnackbar(e && e.graphqlErrors && e.graphqlErrors.length ? e.graphqlErrors[0].debugMessage : 'Download failed',{variant:'error',key:'REPORT_FAILED'});
//            AppToaster.show({ message: e && e.graphqlErrors && e.graphqlErrors.length ? e.graphqlErrors[0].debugMessage : 'Download failed', intent: 'danger' }, toastKey);
            setWait(false);
        }
    }
    let content = null, actions=<></>;
    if(props.isOpen) {
        actions=<>
            <Button color="primary" onClick={props.doClose}>Close</Button>
            <Button color="primary" onClick={submitForm}><Download/>Generate Report</Button>
        </>;
        content = (
            <>
                <FormLabel>Sites to Export</FormLabel>
                <div style={{maxHeight:'50vh',overflowY:'auto'}}>
                <FieldTable setSelectedRows={setSelectedRows} loading={loading}
                            selectedRows={selectedRows} hasDelete={false} values={props.values} columns={ftColumns} hasExport={false} />
                            </div>
            </>);
    }
    return <ModalWindow maxWidth="lg" isOpen={props.isOpen} onClose={props.doClose} header={"Planning Report"} actions={actions}>
        {content}
    </ModalWindow>;
}

export default PlanningReport;